import classnames from 'classnames';
import { d, numeric } from 'shared-base';
import Icon from '../Icon/Icon';
import { toast } from '../Toast/Toast.actions';
import { Copy, Field, Label, Value, Wrapper } from './Details.style';

export type DetailsProps = {
  config: IField[];
  values: Json;
};

type IField = {
  id: string;
  label: string;
  fieldType: 'chip' | 'text' | 'date' | 'number' | 'currency' | 'copy' | string;
};

export function Details(props: DetailsProps) {
  const { config: fields, values } = props;

  function copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    toast.show('Copied to clipboard');
  }

  function renderCopy(value: string) {
    return (
      <Copy className='copy'>
        <Icon onClick={() => copyToClipboard(value)} name='IconCopy' color='#889' />
      </Copy>
    );
  }

  function renderField(field: IField) {
    const { id, label, fieldType } = field;
    let value = values[id];

    try {
      switch (fieldType) {
        case 'number':
          value = numeric(value);
          break;
        case 'date':
          value = d.normal(value);
          break;
      }
    } catch (err) {}

    const className = classnames('field', fieldType, {});

    return (
      <Field key={field.id} className={className}>
        <Value className='value'>{value}</Value>
        <Label>{label}</Label>
        {renderCopy(value)}
      </Field>
    );
  }

  function renderFields() {
    return fields.map((field: IField) => renderField(field));
  }
  return (
    <Wrapper className='Details-wrapper' data-testid='Details-wrapper'>
      {renderFields()}
    </Wrapper>
  );
}

export default Details;
